<div class="card card-default">
  <div class="card-body criteria-box">
    <div class="row">
      <div class="col-6">
        <div class="row">
          <div class="col-5 text-right text-white">
            <label>ประเภทข้อมูล</label>
          </div>
          <div class="col-6">
            <select class="form-control"></select>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-5 text-right text-white">
            <label>ประเภทรายงานการติดต่อ</label>
          </div>
          <div class="col-6">
            <select class="form-control"></select>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-5 text-right text-white">
            <label>หัวข้อการติดต่อ</label>
          </div>
          <div class="col-6">
            <select class="form-control"></select>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-5 text-right text-white">
            <label>สถานะ</label>
          </div>
          <div class="col-6">
            <select class="form-control"></select>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-5 text-right text-white">
            <label>ผู้สร้าง</label>
          </div>
          <div class="col-6">
            <select class="form-control"></select>
          </div>
        </div>

      </div>

      <div class="col-6">

        <fieldset style="border: 1px solid #CCE89E;">
          <legend style="color: #CCE89E;">วันที่สร้าง:</legend>
          <div class="row">
            <div class="col-6">
              <div class="form-group input-group created">
                <label>จาก</label>
                <input type="text" id="txtdocdate" class="form-control ml-3" data-provide="datepicker" />
              </div>
            </div>
            <div class="col-6">
              <div class="form-group input-group created">
                <label>ถึง</label>
                <input type="text" id="txtdocdate" class="form-control ml-3" data-provide="datepicker" />
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset style="border: 1px solid #EFCEC9;;">
          <legend style="color: #EFCEC9;">วันที่แก้ไขล่าสุด:</legend>
          <div class="row">
            <div class="col-6">
              <div class="form-group input-group updated">
                <label>จาก</label>
                <input type="text" id="txtdocdate" class="form-control ml-3" data-provide="datepicker" />
              </div>
            </div>
            <div class="col-6">
              <div class="form-group input-group updated">
                <label>ถึง</label>
                <input type="text" id="txtdocdate" class="form-control ml-3" data-provide="datepicker" />
              </div>
            </div>
          </div>
        </fieldset>

      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 text-center">
        <button class="btn btn-search mr-3">Search</button>
        <button class="btn btn-clear mr-3">Clear</button>
      </div>
    </div>
  </div>
</div>

<div class="card card-default mt-3">
  <div class="card-header">
    <h3 class="card-title text-cust-blue">Report Call Center</h3>
  </div>
  <!-- /.card-header -->
  <div class="card-body">
    <table id="example2" style="width:100%" class="table table-bordered table-hover result-table table-responsive">
      <thead>
        <tr>
          <th class="col-no">ลำดับ</th>
          <th>Case ID</th>
          <th>ชื่อ</th>
          <th>นามสกุล</th>
          <th>ประเภทข้อมูล</th>
          <th>ประเภทรายงานการติดต่อ</th>
          <th>หัวข้อการติดต่อ</th>
          <th>สถานะ</th>
          <th>วันที่สร้าง</th>
          <th>ผู้ที่สร้าง</th>
          <th>วันที่แก้ไขล่าสุด</th>
          <th>ผู้ที่แก้ไข</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="col-no">1</td>
          <td>20200911100025</td>
          <td>ทองดี</td>
          <td>อยู่เย็น</td>
          <td>Call Center</td>
          <td>ร้องเรียน</td>
          <td>ร้องเรียนการขอเงินฝากคืน</td>
          <td>In Progress</td>
          <td>11 Sep 2020</td>
          <td>Agent1</td>
          <td>11 Sep 2020</td>
          <td>Agent1</td>
        </tr>

        <tr>
          <td class="col-no">2</td>
          <td>20200911100025</td>
          <td>ทองสุข</td>
          <td>มากมี</td>
          <td>Email</td>
          <td>สอบถาม</td>
          <td>สอบถามเรื่องการขอเงินฝากคืน</td>
          <td>Close</td>
          <td>15 Sep 2020</td>
          <td>Agent2</td>
          <td>15 Sep 2020</td>
          <td>Agent2</td>
        </tr>

        <tr>
          <td class="col-no">3</td>
          <td>20200911100049</td>
          <td>ทองสุข</td>
          <td>มากมี</td>
          <td>Email</td>
          <td>สอบถาม</td>
          <td>สอบถามเรื่องการขอเงินฝากคืน</td>
          <td>Close</td>
          <td>15 Sep 2020</td>
          <td>Agent2</td>
          <td>15 Sep 2020</td>
          <td>Agent2</td>
        </tr>

        <tr>
          <td class="col-no">4</td>
          <td>20200911100088</td>
          <td>ทองสุข</td>
          <td>มากมี</td>
          <td>Email</td>
          <td>สอบถาม</td>
          <td>สอบถามเรื่องการขอเงินฝากคืน</td>
          <td>Close</td>
          <td>15 Sep 2020</td>
          <td>Agent2</td>
          <td>15 Sep 2020</td>
          <td>Agent2</td>
        </tr>

        <tr>
          <td class="col-no">5</td>
          <td>20200911100029</td>
          <td>ทองสุข</td>
          <td>มากมี</td>
          <td>Email</td>
          <td>สอบถาม</td>
          <td>สอบถามเรื่องการขอเงินฝากคืน</td>
          <td>Close</td>
          <td>15 Sep 2020</td>
          <td>Agent2</td>
          <td>15 Sep 2020</td>
          <td>Agent2</td>
        </tr>
      </tbody>
    </table>
  </div>

</div>


// WEBPACK FOOTER //
// ./src/app/report/report.component.html